<script>
export default {
  props: {
    rules: { type: String, default: '' },
    options: { type: Array, default: () => [] },
    value: { type: [String, Number, Boolean], default: null },
  },
  computed: {
    localModel: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>

<template>
  <ValidationProvider v-slot="{ errors }" :rules="rules" tag="div">
    <BaseRadio
      v-for="option in options"
      :id="option.id"
      :key="option.id"
      v-model="localModel"
      :value="option.value"
    >
      {{ option.text }}
    </BaseRadio>
    <p class="text-red-500 text-xs italic mt-2">
      {{ errors[0] }}
    </p>
  </ValidationProvider>
</template>
